/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import { ConversationAPI, checkStatus, json } from '@driftt/dapper'
import * as ResourcesConstants from 'constants/ResourcesConstants'
import { getAuthorizationHeader } from 'utils/Helpers'
import { RequestContentType } from 'utils/Helpers'

const TagAPI = Marty.createStateSource({
  id: 'TagAPI',
  type: 'http',

  fetchTagsForOrgId(orgId) {
    return this.get({
      url: `${ ResourcesConstants.CUSTOMER_API }/organizations/${ orgId }/tags`,
      headers: getAuthorizationHeader()
    })
  },

  createTagForOrgId(orgId, tagParams) {
    return this.post({
      url: `${ ResourcesConstants.CUSTOMER_API }/organizations/${ orgId }/tags`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify(tagParams)
    })
  },

  updateTagForOrgId(orgId, tagId, tagParams) {
    return this.patch({
      url: `${ ResourcesConstants.CUSTOMER_API }/organizations/${ orgId }/tags/${ tagId }`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify(tagParams)
    })
  },

  deleteTagForOrgId(orgId, tagId) {
    return this.delete({
      url: `${ ResourcesConstants.CUSTOMER_API }/organizations/${ orgId }/tags/${ tagId }`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader()
    })
  },

  addTagsToConversationId(conversationId, tagIds) {
    return this.addTagsToURL(`${ ResourcesConstants.CONVERSATION_API }/conversations/${ conversationId }/tags`, tagIds)
  },

  removeTagsFromConversationId(conversationId, tagIds) {
    return this.removeTagsFromURL(`${ ResourcesConstants.CONVERSATION_API }/conversations/${ conversationId }/tags`, tagIds)
  },

  addTagsToCompanyId(companyId, tagIds) {
    return this.addTagsToURL(`${ ResourcesConstants.CUSTOMER_API }/companies/${ companyId }/tags`, tagIds)
  },

  removeTagsFromCompanyId(companyId, tagIds) {
    return this.removeTagsFromURL(`${ ResourcesConstants.CUSTOMER_API }/companies/${ companyId }/tags`, tagIds)
  },

  addTagsToEndUserId(endUserId, tagIds) {
    return this.addTagsToURL(`${ ResourcesConstants.CUSTOMER_API }/end_users/${ endUserId }/tags`, tagIds)
  },

  removeTagsFromEndUserId(endUserId, tagIds) {
    return this.removeTagsFromURL(`${ ResourcesConstants.CUSTOMER_API }/end_users/${ endUserId }/tags`, tagIds)
  },

  setResponseTags(campaignId, conversationId, questionId, tagIds) {
    return ConversationAPI.patch(`/campaigns/${campaignId}/interactions/${conversationId}/${questionId}/tags`, { tags: tagIds })
      .then(checkStatus)
      .then(json)
  },

  addTagsToURL(url, tagIds) {
    return this.post({
      url,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify(tagIds)
    })
  },

  removeTagsFromURL(url, tagIds) {
    return this.delete({
      url,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify(tagIds)
    })
  }
})

export default TagAPI



// WEBPACK FOOTER //
// ./src/scripts/sources/TagAPI.js